export default __webpack_public_path__ + "static/media/TERMINAL_ICON_11.696916e5.svg";